import { clsx } from 'clsx';
import { forwardRef } from 'react';

import type { ButtonHTMLAttributes } from 'react';

import styles from './OverlayCloseButton.module.css';

import { Icon } from 'components/Icon';

export interface OverlayCloseButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'style'> {
  /** The `aria-label` value of the button. */
  'aria-label': string; // mandatory
  /** `true` to add padding around the button; otherwise, `false`. The default is `false`. */
  paddedModal?: boolean;
}

/** Represents a component to render a close button in the top right corner of a container. */
export const OverlayCloseButton = forwardRef<HTMLButtonElement, OverlayCloseButtonProps>(
  ({ paddedModal, ...restProps }, forwardedRef) => (
    <button
      {...restProps}
      type="button"
      ref={forwardedRef}
      className={clsx(styles['overlay-close-button'], {
        [styles['overlay-close-button--padded']]: paddedModal,
      })}
    >
      <Icon name="Cross" size={24} />
    </button>
  )
);
